import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
// import { Message, MessageBox } from 'element-ui'
import NProgress from 'nprogress'

import { STATUS_CODE } from './constants'

const whiteUrls = ['account/get_user_info']

const service = axios.create({
  baseURL: '/action', // api的base_url
  timeout: 60000 // 请求超时时间, 单位 ms
})

// 让智能网关识别这是 ajax 请求
service.defaults.headers.common['x-requested-with'] = 'XMLHttpRequest'

// request拦截器
service.interceptors.request.use(config => {
  NProgress.start()

  // 过滤所有值是 空字符串 的参数
  if (config.noEmpty && config.method === 'post' && config.data) {
    const postData = config.data
    for (const key in postData) {
      if (postData[key] === '') {
        postData[key] = undefined
      }
    }
    config.data = postData
  }

  return config
}, error => {
  console.error(error)
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(response => {
  NProgress.done()
  const res = response.data

  if (res.code !== STATUS_CODE.SUCCESS) {
    if (res.code === -401) { // 登录过期
      res.message = '您需要重新登录'

      if (whiteUrls.some(url => response.config.url.startsWith(url))) {
        // 满足白名单, 由上层决定如何处理
        // 1. 路由切换时会请求 /action/get_user_info, 如果未登录,由上层方法决定如果处理

      } else {
        store.commit('login', true)
      }

      return Promise.reject(res)
    }

    // 其他错误
    res.message = res.msg
    return Promise.reject(res)
  } else {
    return res.data
  }
}, error => {
  NProgress.done()
  if (axios.isCancel(error)) {
    return Promise.reject(error)
  } else if (error.code === 'ECONNABORTED') {
    error.message = '请求无响应'
    return Promise.reject(error)
  } else if (error.response) {
    if (error.response.status === 500) {
      error.message = 'OOPS!系统发生异常，请稍后再试。'
    } else {
      error.message = `抱歉，您请求的资源不存在【${error.response.status}-${error.response.statusText}】`
    }
  } else {
    error.message = '未知异常，请联系管理员...'
  }

  return Promise.reject(error)
})

Vue.prototype.$http = service

export default service
